import React from 'react';
import Page from '../components/Page';

function Reports() {
  return (
    <Page>
      <p style={{ color: 'white' }}>TODO</p>
    </Page>
  );
}

export default Reports;
